module.exports = __webpack_public_path__ + "img/chevron-compact-down.3033c51b.svg";